module.exports = __webpack_public_path__ + "img/12-4.e016b7c3.png";